module.exports = __webpack_public_path__ + "static/img/bg-pt.4908f047.png";